import { Calendar, ArrowRight } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { paths } from 'src/routes/paths'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { Button } from 'src/shared/components/ui/button'
import { RolePageData } from '../../types'

interface RoleHeroSectionProps {
  data: RolePageData
}

export const RoleHeroSection = ({ data }: RoleHeroSectionProps) => {
  const navigate = useNavigate()

  const handlePrimaryCTA = () => {
    navigate(paths.loginSignUp)
  }

  return (
    <section className="w-full py-24 bg-gradient-to-b from-white via-stone-50 to-stone-100 relative overflow-hidden">
      {/* Decorative gradient blobs */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-blue-100/30 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-stone-200/40 rounded-full blur-3xl" />

      <Column className="w-full max-w-5xl mx-auto px-8 gap-12 relative z-10">
        {/* Role badge */}
        <Row className="items-center gap-3 justify-center">
          <div className="w-10 h-10 rounded-lg bg-slate-100/80 backdrop-blur-sm flex items-center justify-center">
            <data.icon className="w-5 h-5 text-slate-700" strokeWidth={1.5} />
          </div>
          <span className="text-lg font-normal text-slate-600">
            For {data.label}
          </span>
        </Row>

        {/* Main headline - Job to be done */}
        <Column className="gap-6 text-center">
          <h1 className="text-4xl text-slate-800 max-w-3xl mx-auto leading-tight">
            {data.jobToBeDone}
          </h1>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            {data.context}
          </p>
        </Column>

        {/* CTA buttons */}
        <Row className="gap-4 justify-center">
          <Button
            variant="primary"
            size="lg"
            onClick={handlePrimaryCTA}
            className="px-8 py-6 text-base"
          >
            {data.cta.primary}
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>

          <Button
            variant="secondary"
            size="lg"
            onClick={() => navigate(`${paths.contact}`)}
            className="px-8 py-6 text-base"
          >
            <Calendar className="w-5 h-5 mr-2" />
            Book a meeting
          </Button>
        </Row>

        {/* Daily reality */}
        <Column className="gap-4 mt-8">
          <p className="text-center text-sm font-medium text-slate-500 uppercase tracking-wider">
            Sound familiar?
          </p>
          <Row className="flex-wrap gap-3 justify-center">
            {data.dailyReality.map((item, index) => (
              <span
                key={index}
                className="px-4 py-2 bg-white/70 backdrop-blur-sm border border-white/60 rounded-full text-sm text-slate-600 shadow-sm"
              >
                {item}
              </span>
            ))}
          </Row>
        </Column>
      </Column>
    </section>
  )
}
